import { StockTypesEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class InputIdRequest {
    @ApiProperty()
    inputId: number;
    @ApiProperty()
    dispatchType?: StockTypesEnum;
}
